import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { TS_EditableItemComponent } from '@nu-art/thunderstorm-frontend/components/TS_EditableItemComponent/TS_EditableItemComponent';
import { Editor_Term } from '../editors/Editor_Term.js';
import { Button, LL_V_L } from '@nu-art/thunderstorm-frontend/index';
import './Component_StructuredComplexLogic.scss';
import { getEmptyTerm } from '../../../../../../_entity/expression/utils.js';
export class Component_StructuredComplexLogic extends TS_EditableItemComponent {
    //######################### Logic #########################
    deleteSubTerm = async (index) => {
        const editableSubTerms = this.state.editable.editProp('subTerms', []);
        if (editableSubTerms.item.length === 1) {
            return this.props.resetExpression();
        }
        await editableSubTerms.removeArrayItem(index);
    };
    addSubTerm = async () => {
        const editableSubTerms = this.state.editable.editProp('subTerms', []);
        const previousSubTerm = editableSubTerms.get(editableSubTerms.item.length - 1);
        const newSubTerm = getEmptyTerm();
        if (!previousSubTerm)
            return editableSubTerms.updateArrayAt(newSubTerm);
        // maintain left-hand values from previous sub term
        newSubTerm.atoms = previousSubTerm.atoms.reduce((atoms, currentAtom, currentIndex) => {
            currentAtom.leftHand = previousSubTerm.atoms[currentIndex].leftHand;
            atoms.push(currentAtom);
            return atoms;
        }, []);
        await editableSubTerms.updateArrayAt(newSubTerm);
    };
    //######################### Render #########################
    renderSubTerms = () => {
        const subTerms = this.state.editable.editProp('subTerms', [getEmptyTerm()]);
        return _jsx(LL_V_L, { className: 'sub-term-list', children: subTerms.item.map((subTerm, index) => {
                const editableSubTerm = subTerms.editProp(index, getEmptyTerm);
                return _jsxs(LL_V_L, { className: 'sub-term-list__sub-term-container', children: [_jsx("div", { className: 'sub-term-list__title', children: `Sub-Term ${index + 1}` }), _jsx(Editor_Term, { usedVarIds: [], isSubTerm: true, termAtoms: this.state.editable.get('atoms'), deleteTerm: () => this.deleteSubTerm(index), editable: editableSubTerm })] }, index);
            }) });
    };
    render() {
        return _jsxs(LL_V_L, { className: 'structured-complex-logic', children: [_jsx("div", { className: 'structured-complex-logic__title', children: "Edit Sub-Terms" }), this.renderSubTerms(), _jsx(Button, { variant: 'primary', className: 'add-entity-btn', onClick: this.addSubTerm, children: "Add Sub-Term" })] });
    }
}
//# sourceMappingURL=Component_StructuredComplexLogic.js.map